module.exports = __webpack_public_path__ + "static/media/BGP-TIJSeries.bff8b0b4.pdf";